import React, { useCallback } from 'react';
import { ListFilterItem } from '../../types';
import * as S from './styles';

type RadioButtonProps = {
  item: ListFilterItem;
  selected: boolean;
  onClick: (id: string) => void;
};

const RadioButton = ({ item, selected, onClick }: RadioButtonProps) => {
  const { id, value, count, path, indexable } = item;
  const onClickItem = useCallback(
    e => {
      // Help google with a-links, but handle filter updates via actions
      e.preventDefault();

      onClick(id);
    },
    [onClick, id]
  );

  return (
    <S.OptionListItem key={id}>
      <S.Option to={(indexable && path) || undefined} onClick={onClickItem}>
        <S.RadioButton checked={selected} />
        <S.Name>{value}</S.Name>
        {count !== undefined && <S.Count>{count}</S.Count>}
      </S.Option>
    </S.OptionListItem>
  );
};

type Props = {
  items: ListFilterItem[];
  getSelectedState: (id: string) => boolean;
  onClickItem: (id: string) => void;
};

const RadioButtons = ({ items, getSelectedState, onClickItem }: Props) => {
  return (
    <>
      {items.map(item => (
        <RadioButton
          key={item.id}
          item={item}
          selected={getSelectedState(item.id)}
          onClick={onClickItem}
        />
      ))}
    </>
  );
};

export default RadioButtons;
